import { axios } from '../../utilities/axiosClient'
import { Journals } from '../../types/Journal'

type JournalProps = {
  count?: number
}

export const getJournal = (params?: JournalProps): Promise<Journals> =>
  axios.post('/api/journal', params)
